import { render, staticRenderFns } from "./addBidNotice.vue?vue&type=template&id=1b5c4803&scoped=true"
import script from "./addBidNotice.vue?vue&type=script&lang=js"
export * from "./addBidNotice.vue?vue&type=script&lang=js"
import style0 from "./addBidNotice.vue?vue&type=style&index=0&id=1b5c4803&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5c4803",
  null
  
)

export default component.exports